<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>


        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="3"></Aide>

        <h3 class="titreSolu text-center">Gestion tâche</h3>
        <b-collapse id="collapse-2">
            <h4 class="text-center">Créer une tâche</h4>
            <div>
                <div class="row" style="margin-top: 75px;">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Intitulé
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="intituleTache" name="intituleTache" placeholder="Intitulé">
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Type
                    </div>
                    <div class="col-7">
                        <select v-model="typeMachine" class="form-control" name="typeMachine">
                            <option v-for="(lType, key) in listMachineType" :key="key"
                                    v-bind:value="lType['@id']">{{ lType.intitule }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Niveau
                    </div>
                    <div class="col-3">
                        <select v-model="niveauTache" class="form-control" name="typeTpsRappel">
                            <option v-for="(lType, key) in listNiveauTache" :key="key"
                                    v-bind:value="key">{{ lType }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        mise en charge/à niveau
                    </div>
                    <div class="col-3">
                        <select v-model="miseChargNive" class="form-control" name="typeTpsRappel">
                            <option v-for="(mcn, key) in listMiseChargNive" :key="key"
                                    v-bind:value="key">{{ mcn }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Temps rappel
                    </div>
                    <div class="col-3">
                        <input type="number" class="form-control" v-model="tpsRappel" name="tpsRappel" placeholder="unité de temps">
                    </div>
                    <div class="col-3">
                        <select v-model="typeTpsRappel" class="form-control" name="typeTpsRappel">
                            <option v-for="(lType, key) in listType" :key="key"
                                    v-bind:value="key">{{ lType }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                    </div>
                    <div class="col-6">
                        <span class="text-warning">Pour ne pas avoir de rappel, laissez à 0.</span>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="addTache()" >
                            Valider
                        </button>
                    </div>
                </div>
            </div>
        </b-collapse>


        <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
            <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
        </div>
        <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
            <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
        </div>
        <div>
            <h4 class="text-center">Liste des taches existantes</h4>
            <div class="row">
                <div class="col-12 text-right">
                    <button v-b-toggle="'collapse-2'" class="btn btn-primary"><i class="fa-solid fa-plus"></i> Ajout Tache</button>
                </div>
            </div>
            <table  v-if="listTache.length>0" class="table table-striped table-bordered " >
                <tr>
                    <th class="thtab">Intitulé</th>
                    <th class="thtab">Type</th>
                    <th class="thtab">Niveau</th>
                    <th class="thtab">Niveau/charge</th>
                    <th class="thtab" colspan="2">Rappel</th>
                    <th class="thtab"></th>
                    <th class="thtab"></th>
                </tr>
                <tr v-for="(tache, key) in listTache" :key="key" >
                    <td>
                        <span v-if="keyUpd!=key">{{tache.intitule}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="intituleTacheUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                            <span v-for="(lType, key) in listMachineType" :key="key">
                                <span v-if="lType['@id']==tache.typeMachine">{{lType.intitule}}</span>
                            </span>
                        </span>
                        <select v-if="keyUpd==key" v-model="typeMachineUpd" class="form-control" name="typeMachine">
                            <option v-for="(lType, key) in listMachineType" :key="key"
                                    v-bind:value="lType['@id']">{{ lType.intitule }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">{{listNiveauTache[tache.niveau]}}</span>
                        <select v-if="keyUpd==key" v-model="niveauTacheUpd" class="form-control" name="typeTpsRappel">
                            <option v-for="(lNiv, key) in listNiveauTache" :key="key"
                                    v-bind:value="key">{{ lNiv }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">{{listMiseChargNive[tache.miseChargNive]}}</span>

                        <select  v-if="keyUpd==key" v-model="miseChargNiveUpd" class="form-control" name="typeTpsRappel">
                            <option v-for="(mcn, key) in listMiseChargNive" :key="key"
                                    v-bind:value="key">{{ mcn }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key && tache.tpsRappel!=0">{{tache.tpsRappel}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="tpsRappelUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key && tache.tpsRappel!=0">{{listType[tache.typeTpsRappel]}}</span>
                        <select v-if="keyUpd==key" v-model="typeTpsRappelUpd" class="form-control" name="typeMachine">
                            <option v-for="(lType, key) in listType" :key="key"
                                    v-bind:value="key">{{ lType }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <i v-if="keyUpd!=key" class="fa-solid fa-pen-to-square fa-2x text-warning" @click="beforeUpdate(key)"></i>
                        <i v-if="keyUpd==key" class="fa-solid fa-check fa-2x text-success" @click="valideUpdate(key)"></i>
                        &nbsp;
                        <i v-if="keyUpd==key" class="fa-solid fa-xmark fa-2x text-danger" @click="cancel()"></i>
                    </td>
                    <td>
                        <i class="fa-regular fa-trash-can fa-2x text-danger" @click="deleteObjet(key)"></i>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row">
            <div class="col-12 text-center text-info">
                {{listTache.length}} entité(s)
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';

    export default {
        name: "Tache",
        props: ['token', 'site', 'user', 'racine', 'userId','systemeClient'],
        data() {
            return {
                intituleTache:'',niveauTache:1,errors:[],msgs:[],listType:{1:'jour',2:'semaine',3:'mois',4:'année'},
                listTache:[], intituleTacheUpd:'',keyUpd:null,checkValideMachin:true,
                typeTpsRappel:1,tpsRappel:0,tpsRappelUpd:0,typeTpsRappelUpd:0,listNiveauTache:{1:'Standard',2:'Supérieur'},
                niveauTacheUpd:'',listMachineType:[],typeMachine:null,typeMachineUpd:null,
                listMiseChargNive:{0:'Aucun',1:'Mise en charge',2:'Mise à niveau'},miseChargNive:0
            };
        },
        methods:
            {
                tokenValide(json) {
                    if (json['status'] == '401') {
                        this.$emit('token')
                    }
                },
                addTache()
                {
                    this.errors = [];
                    this.msgs = [];
                    if(this.intituleTache!='') {
                        console.log(this.intituleTache)


                        var formdata = new FormData();
                        formdata.append('intitule', this.intituleTache);


                        fetch(this.racine + this.site + 'api/taches', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                            body: "{\"intitule\":\"" + this.intituleTache + "\"," +
                            "\"tpsRappel\":" + this.tpsRappel + "," +
                            "\"typeTpsRappel\":" + this.typeTpsRappel + "," +
                            "\"typeMachine\": \"" + this.typeMachine + "\"," +
                            "\"niveau\":" + this.niveauTache + "," +
                            "\"miseChargNive\":" + this.miseChargNive + "," +
                            "\"systemeClient\": \"" + this.systemeClient + "\"" +
                            "}"
                        }).then(response => response.json())
                            .then(json => {
                                console.log(json);
                                if (json['@type'] == "hydra:Error") {
                                    this.errors.push("Cet intitule est déjà utilisé.")
                                    this.popup()
                                }
                                else if (json['id'] > 0) {
                                    this.msgs.push("Ajout de la tache effectué.")
                                    this.getTaches()
                                    this.intituleTache = ''
                                    this.popup()
                                }
                                else {
                                    this.errors.push("Un problème inconnu s'est produit.")
                                    this.popup()
                                }
                            })
                    }
                    else
                    {
                        this.errors.push("Vous devez remplir l'intitule.");
                    }


                },
                getTaches()
                {
                    fetch(this.racine + this.site + 'api/taches?systemeClient='+this.systemeClient, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listTache = json['hydra:member']
                            }
                        })
                    })
                },
                beforeUpdate(keyTache)
                {
                    //on charge les données de la ligne dans les variables pour l'update
                    this.keyUpd = keyTache
                    this.intituleTacheUpd = this.listTache[this.keyUpd].intitule
                    this.typeTpsRappelUpd = this.listTache[this.keyUpd].typeTpsRappel
                    this.tpsRappelUpd = this.listTache[this.keyUpd].tpsRappel
                    this.niveauTacheUpd = this.listTache[this.keyUpd].niveau
                    this.typeMachineUpd = this.listTache[this.keyUpd].typeMachine
                    this.miseChargNiveUpd = this.listTache[this.keyUpd].miseChargNive
                },
                valideUpdate(key)
                {
                    this.errors = [];
                    this.msgs = [];
                    if(this.intituleTacheUpd!='') {
                        this.$confirm(
                            {
                                title: 'Etes vous sûr?',
                                message: 'Etes vous sur de vouloir modifier ' + this.listTache[key].intitule + '?',
                                button: {
                                    yes: 'Oui',
                                    no: 'Non'
                                },
                                callback: confirm => {
                                    if (confirm == true) {
                                        fetch(this.racine + this.site + 'api/taches/'+this.listTache[key].id, {
                                            method: 'PUT',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': 'Bearer ' + this.token
                                            },
                                            body: "{\"intitule\":\"" + this.intituleTacheUpd + "\"," +
                                            "\"tpsRappel\":" + this.tpsRappelUpd + "," +
                                            "\"typeTpsRappel\":" + this.typeTpsRappelUpd + "," +
                                            "\"typeMachine\": \"" + this.typeMachineUpd + "\"," +
                                            "\"niveau\":" + this.niveauTacheUpd + "," +
                                            "\"miseChargNive\":" + this.miseChargNiveUpd + "," +
                                            "\"systemeClient\": \"" + this.systemeClient + "\"" +
                                            "}"
                                        }).then(response => response.json())
                                            .then(json => {
                                                console.log(json);
                                                if (json['@type'] == "hydra:Error") {
                                                    this.errors.push("Cet intitule est déjà utilisé.")
                                                    this.popup()
                                                }
                                                else if (json['id'] > 0) {
                                                    this.msgs.push("Modification de la tache effectué.")
                                                    this.getTaches()
                                                    this.intituleTache = ''
                                                    this.popup()
                                                    this.keyUpd = null
                                                }
                                                else {
                                                    this.errors.push("Un problème inconnu s'est produit.")
                                                    this.popup()
                                                }
                                            })
                                    }
                                }
                            }
                        )
                    }
                    else
                    {
                        this.errors.push('Vous devez remplir le intitule.');
                    }
                },
                popup()
                {
                    this.$bvModal.show('modalInfo')
                    setTimeout(() => {//on laisse le message quelques instants
                        this.$bvModal.hide('modalInfo')
                        this.errors = []
                        this.msgs = []
                    }, 2000)
                },
                cancel()
                {
                    this.keyUpd = null
                },
                deleteObjet(key)
                {
                    var self = this
                    this.$confirm(
                        {
                            title: 'Etes vous sûr?',
                            message: 'Etes vous sur de vouloir supprimer ' + this.listTache[key].intitule + '?',
                            button: {
                                yes: 'Oui',
                                no: 'Non'
                            },
                            callback: confirm => {
                                if (confirm == true) {
                                    fetch(this.racine + this.site + 'api/taches/'+this.listTache[key].id, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        }
                                    }).then(function(response) {
                                        console.log(response.ok)
                                        if(response.ok == true)
                                        {
                                            self.getTaches()
                                            self.keyUpd = null
                                            self.msgs.push("Suppression de la tache effectuée.")
                                            self.popup()
                                        }
                                        else {
                                            self.errors.push("Un problème inconnu s'est produit.")
                                            self.popup()
                                        }

                                    })
                                }
                            }
                        }
                    )
                },
                getMachineTypes()
                {
                    fetch(this.racine + this.site + 'api/machine_types?systemeClient='+this.systemeClient, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listMachineType = json['hydra:member']
                            }
                        })
                    })
                },
            },
        mounted() {
            this.getTaches()
            this.getMachineTypes()
        },
        created() {
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>